import { NgModule } from '@angular/core';
import { LangPipe } from './lang.pipe';
import { LangProvider } from './lang.provider';

@NgModule({
  imports: [],
  declarations: [
    LangPipe
  ],
  exports: [
    LangPipe
  ],
  providers: [
    LangProvider,
    LangPipe
  ]
})
export class LangModule {
}
